import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9c994d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-min-h-[calc(100vh-var(--header-height,0px))] tw-bg-gradient-to-br tw-from-orange-50 tw-via-white tw-to-amber-50 tw-px-4 tw-py-8 md:tw-px-8" }
const _hoisted_2 = {
  key: 0,
  class: "tw-rounded-lg tw-border tw-border-red-200 tw-bg-white tw-p-8 tw-text-center tw-shadow-sm"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "tw-m-0 tw-text-2xl tw-font-bold tw-text-gray-900" }, " Not Permitted ", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-mt-3 tw-text-sm tw-text-gray-600" }, " You are not allowed to access this E-Invoice Request. ", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/my-orders",
  class: "tw-mt-6 tw-inline-flex tw-rounded-md tw-bg-orange-500 tw-px-5 tw-py-2.5 tw-text-sm tw-font-bold tw-text-white"
}, " Back to My Orders ", -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "tw-rounded-xl tw-border tw-border-amber-200 tw-bg-amber-50 tw-p-8 tw-text-center tw-shadow-sm"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"tw-mx-auto tw-mb-5 tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full tw-bg-amber-100\" data-v-f9c994d2><svg class=\"tw-h-7 tw-w-7 tw-text-amber-600\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" viewBox=\"0 0 24 24\" data-v-f9c994d2><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\" data-v-f9c994d2></path></svg></div><h3 class=\"tw-m-0 tw-text-2xl tw-font-bold tw-text-gray-900\" data-v-f9c994d2> E-Invoice Request Expired </h3><p class=\"tw-mx-auto tw-mt-3 tw-max-w-xl tw-text-sm tw-leading-6 tw-text-gray-600\" data-v-f9c994d2> This e-Invoice request has expired and can no longer be submitted. Please return to My Orders or contact support if you need further assistance. </p><div class=\"tw-mt-6 tw-flex tw-justify-center\" data-v-f9c994d2><a href=\"/my-orders\" class=\"tw-inline-flex tw-min-h-11 tw-items-center tw-justify-center tw-rounded-md tw-bg-orange-500 tw-px-5 tw-py-2.5 tw-text-sm tw-font-bold tw-text-white tw-no-underline tw-shadow-sm tw-transition hover:tw-bg-orange-600 hover:tw-no-underline\" data-v-f9c994d2> Back to My Orders </a></div>", 4)
const _hoisted_12 = [
  _hoisted_8
]
const _hoisted_13 = {
  key: 2,
  class: "tw-rounded-lg tw-border tw-border-red-200 tw-bg-white tw-p-8 tw-text-center tw-shadow-sm"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "tw-m-0 tw-text-2xl tw-font-bold tw-text-gray-900" }, " E-Invoice Already Consolidated ", -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-mt-3 tw-text-sm tw-text-gray-600" }, " This invoice has been consolidated. Individual submissions are no longer allowed. ", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/my-orders",
  class: "tw-mt-6 tw-inline-flex tw-rounded-md tw-bg-orange-500 tw-px-5 tw-py-2.5 tw-text-sm tw-font-bold tw-text-white"
}, " Back to My Orders ", -1 /* HOISTED */))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 3,
  class: "tw-mx-auto tw-w-full tw-max-w-3xl"
}
const _hoisted_19 = { class: "tw-mb-6 tw-rounded-lg tw-border tw-border-orange-100 tw-bg-white/90 tw-p-5 tw-shadow-sm md:tw-p-6" }
const _hoisted_20 = { class: "tw-flex tw-flex-col tw-gap-4 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-mb-2 tw-text-sm tw-font-semibold tw-text-orange-600" }, "WinHoo E-Invoice"),
  /*#__PURE__*/_createElementVNode("h4", { class: "tw-m-0 tw-text-2xl tw-font-bold tw-leading-tight tw-text-gray-950 md:tw-text-3xl" }, " E-Invoice Request "),
  /*#__PURE__*/_createElementVNode("p", { class: "tw-mt-2 tw-mb-0 tw-max-w-2xl tw-text-sm tw-leading-6 tw-text-gray-600" }, " Request your e-invoice by completing the information below. ")
], -1 /* HOISTED */))
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 0,
  class: "tw-mb-4 tw-rounded-lg tw-border tw-border-green-200 tw-bg-green-50 tw-p-4 tw-text-center tw-text-green-800"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-mx-auto tw-mb-2 tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-green-600 tw-text-white" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check tw-text-lg" })
], -1 /* HOISTED */))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-m-0 tw-text-sm tw-font-semibold" }, " Congratulations! Your E-Invoice request has been successfully submitted. ", -1 /* HOISTED */))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "tw-grid tw-gap-4" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tw-m-0 tw-font-bold tw-uppercase tw-tracking-normal tw-text-gray-900" }, "Invoice Details", -1 /* HOISTED */))
const _hoisted_29 = { class: "tw-grid tw-gap-4 md:tw-grid-cols-2" }
const _hoisted_30 = { class: "tw-flex tw-flex-col" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "pos_invoice_no",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Order ID "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_32 = { class: "tw-flex tw-flex-col" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700",
  for: "date"
}, [
  /*#__PURE__*/_createTextVNode(" Transaction Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "tw-my-6 tw-border-gray-200" }, null, -1 /* HOISTED */))
const _hoisted_35 = { class: "tw-grid tw-gap-4" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tw-m-0 tw-font-bold tw-uppercase tw-tracking-normal tw-text-gray-900" }, "Personal Details", -1 /* HOISTED */))
const _hoisted_37 = { class: "tw-flex tw-flex-col" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "full_name",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Full Name (as per ID) "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_39 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_40 = { class: "tw-grid tw-gap-4 md:tw-grid-cols-2" }
const _hoisted_41 = { class: "tw-flex tw-flex-col" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email-field",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Email Address "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_43 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_44 = { class: "tw-flex tw-flex-col" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Phone Number "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_46 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_47 = { class: "tw-space-y-2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "customer_type",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, "Claim as:", -1 /* HOISTED */))
const _hoisted_49 = { class: "tw-grid tw-gap-1 sm:tw-grid-cols-2" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Individual", -1 /* HOISTED */))
const _hoisted_52 = ["disabled"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Company", -1 /* HOISTED */))
const _hoisted_54 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_55 = {
  key: 0,
  class: "tw-my-6 tw-border-gray-200"
}
const _hoisted_56 = {
  key: 1,
  class: "tw-grid tw-gap-4"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tw-m-0 tw-font-bold tw-uppercase tw-tracking-normal tw-text-gray-900" }, "Individual Details", -1 /* HOISTED */))
const _hoisted_58 = { class: "tw-flex tw-flex-col" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "individual-type",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Individual ID Type"),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_60 = { class: "tw-grid tw-gap-1 sm:tw-grid-cols-3" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "MyKad", -1 /* HOISTED */))
const _hoisted_63 = ["disabled"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Passport", -1 /* HOISTED */))
const _hoisted_65 = ["disabled"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "MyTentera", -1 /* HOISTED */))
const _hoisted_67 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_68 = { class: "tw-grid tw-gap-4 md:tw-grid-cols-2" }
const _hoisted_69 = { class: "tw-flex tw-flex-col" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Individual ID "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_71 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_72 = { class: "tw-flex tw-flex-col" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "individual_tin",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Individual Tax Identification Number (TIN) "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_74 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_75 = {
  key: 2,
  class: "tw-grid tw-gap-4"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tw-m-0 tw-font-bold tw-uppercase tw-tracking-normal tw-text-gray-900" }, "Company Details", -1 /* HOISTED */))
const _hoisted_77 = { class: "tw-flex tw-flex-col" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "company-name",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Company Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_79 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_80 = { class: "tw-grid tw-gap-4 md:tw-grid-cols-2" }
const _hoisted_81 = { class: "tw-flex tw-flex-col" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "company_id",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Business Registration Number (BRN) "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_83 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_84 = { class: "tw-flex tw-flex-col" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "company_tin",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Company Tax Identification Number (TIN) "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_86 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_87 = { class: "tw-flex tw-flex-col" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "company_sst_number",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, "SST Registration Number (Mandatory for SST-registrant)", -1 /* HOISTED */))
const _hoisted_89 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "tw-my-6 tw-border-gray-200" }, null, -1 /* HOISTED */))
const _hoisted_91 = { class: "tw-grid tw-gap-4" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tw-m-0 tw-font-bold tw-uppercase tw-tracking-normal tw-text-gray-900" }, "Address Details", -1 /* HOISTED */))
const _hoisted_93 = { class: "tw-flex tw-flex-col" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "address_line_1",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Address Line 1 "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_95 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_96 = { class: "tw-flex tw-flex-col" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "address_line_2",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, "Address Line 2", -1 /* HOISTED */))
const _hoisted_98 = { class: "tw-grid tw-gap-4 md:tw-grid-cols-2" }
const _hoisted_99 = { class: "tw-flex tw-flex-col" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "country",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Country "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_101 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_102 = { class: "tw-flex tw-flex-col" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" State "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_104 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_105 = { class: "tw-grid tw-gap-4 md:tw-grid-cols-2" }
const _hoisted_106 = { class: "tw-flex tw-flex-col" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" City "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_108 = {
  key: 3,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_109 = { class: "tw-flex tw-flex-col" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "postal_code",
  class: "tw-block tw-text-sm tw-font-semibold tw-text-gray-700"
}, [
  /*#__PURE__*/_createTextVNode(" Postal Code "),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-red-500" }, "*")
], -1 /* HOISTED */))
const _hoisted_111 = {
  key: 0,
  class: "tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_112 = ["disabled"]
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "agreement",
  class: "tw-m-0 tw-cursor-pointer tw-text-sm tw-font-normal tw-leading-6 tw-text-gray-600"
}, [
  /*#__PURE__*/_createTextVNode(" By ticking this box, you consent to abide by the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: `/terms-and-conditions`,
    target: "_blank",
    class: "tw-font-medium tw-text-orange-600 tw-underline tw-underline-offset-2"
  }, "Terms and Conditions"),
  /*#__PURE__*/_createTextVNode(" as well as "),
  /*#__PURE__*/_createElementVNode("a", {
    href: `/privacy-policy`,
    target: "_blank",
    class: "tw-font-medium tw-text-orange-600 tw-underline tw-underline-offset-2"
  }, "Privacy Policy"),
  /*#__PURE__*/_createTextVNode(" outlined herein. Please review the terms carefully before proceeding. Your acceptance indicates your understanding and agreement to be bound by these terms. ")
], -1 /* HOISTED */))
const _hoisted_114 = {
  key: 0,
  class: "tw-col-start-2 tw-m-0 tw-text-sm tw-text-red-600"
}
const _hoisted_115 = { class: "tw-mt-6 tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row tw-justify-end" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/my-orders",
  class: "tw-inline-flex tw-min-h-11 tw-w-full tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-5 tw-py-2.5 tw-text-sm tw-font-bold tw-text-gray-700 tw-shadow-sm tw-no-underline tw-transition hover:tw-bg-gray-50 hover:tw-no-underline sm:tw-w-auto"
}, " Back ", -1 /* HOISTED */))
const _hoisted_117 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Select = _resolveComponent("Select")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.isPermitted == false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [..._hoisted_6]))
      : ($data.isExpired)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [..._hoisted_12]))
        : (this.formData.submitted_in_consolidated_einvoice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [..._hoisted_17]))
          : ($data.isPermitted == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    ($data.logo_file_path)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $data.logo_file_path,
                          alt: "Logo",
                          class: "tw-h-12 tw-w-auto tw-object-contain"
                        }, null, 8 /* PROPS */, _hoisted_22))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                ($data.isSubmitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [..._hoisted_26]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("form", {
                  onSubmit: _cache[43] || (_cache[43] = _withModifiers((...args) => ($options.submitForm && $options.submitForm(...args)), ["prevent"])),
                  novalidate: "",
                  class: "tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-p-5 tw-shadow-sm md:tw-p-6"
                }, [
                  _createElementVNode("section", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createVNode(_component_InputText, {
                          type: "text",
                          modelValue: $data.formData.voucher_no,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.formData.voucher_no) = $event)),
                          placeholder: "POS Invoice No",
                          readonly: ""
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createVNode(_component_InputText, {
                          type: "text",
                          modelValue: $data.formData.transaction_date,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.formData.transaction_date) = $event)),
                          placeholder: "Date",
                          readonly: ""
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ])
                    ])
                  ]),
                  _hoisted_34,
                  _createElementVNode("section", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_component_InputText, {
                        class: _normalizeClass(["tw-flex-1", $options.inputErrorClass('full_name')]),
                        type: "text",
                        modelValue: $data.formData.full_name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.formData.full_name) = $event)),
                        placeholder: "e.g. Syatifah binti Ibrahim",
                        required: "",
                        disabled: $data.isSubmitted,
                        onInput: _cache[3] || (_cache[3] = $event => ($options.clearFieldError('full_name')))
                      }, null, 8 /* PROPS */, ["class", "modelValue", "disabled"]),
                      ($data.form_error_data.full_name)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString($data.form_error_data.full_name), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createVNode(_component_InputText, {
                          id: "email-field",
                          type: "text",
                          modelValue: $data.formData.email_address,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.formData.email_address) = $event)),
                          placeholder: "e.g. syatifah@gmail.com",
                          required: "",
                          disabled: $data.isSubmitted,
                          class: _normalizeClass($options.inputErrorClass('email_address')),
                          onInput: _cache[5] || (_cache[5] = $event => ($options.clearFieldError('email_address')))
                        }, null, 8 /* PROPS */, ["modelValue", "disabled", "class"]),
                        ($data.form_error_data.email_address)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString($data.form_error_data.email_address), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createVNode(_component_InputText, {
                          id: "phone",
                          type: "tel",
                          class: _normalizeClass(["tw-w-full", $options.inputErrorClass('phone_number')]),
                          disabled: $data.isSubmitted,
                          required: ""
                        }, null, 8 /* PROPS */, ["class", "disabled"]),
                        ($data.form_error_data.phone_number)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString($data.form_error_data.phone_number), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("label", {
                          for: "individual",
                          class: _normalizeClass(["tw-choice-card", $options.choiceClass('customer_type', $data.formData.customer_type === 'Individual')])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            class: "tw-radio",
                            type: "radio",
                            name: "customer_type",
                            value: "Individual",
                            id: "individual",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.formData.customer_type) = $event)),
                            required: "",
                            disabled: $data.isSubmitted,
                            onChange: _cache[7] || (_cache[7] = $event => ($options.clearFieldError('customer_type')))
                          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_50), [
                            [_vModelRadio, $data.formData.customer_type]
                          ]),
                          _hoisted_51
                        ], 2 /* CLASS */),
                        _createElementVNode("label", {
                          for: "company",
                          class: _normalizeClass(["tw-choice-card", $options.choiceClass('customer_type', $data.formData.customer_type === 'Company')])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            class: "tw-radio",
                            type: "radio",
                            name: "customer_type",
                            value: "Company",
                            id: "company",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($data.formData.customer_type) = $event)),
                            required: "",
                            disabled: $data.isSubmitted,
                            onChange: _cache[9] || (_cache[9] = $event => ($options.clearFieldError('customer_type')))
                          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_52), [
                            [_vModelRadio, $data.formData.customer_type]
                          ]),
                          _hoisted_53
                        ], 2 /* CLASS */)
                      ]),
                      ($data.form_error_data.customer_type)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString($data.form_error_data.customer_type), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  ($data.formData.customer_type)
                    ? (_openBlock(), _createElementBlock("hr", _hoisted_55))
                    : _createCommentVNode("v-if", true),
                  ($data.formData.customer_type === 'Individual')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("div", _hoisted_58, [
                          _hoisted_59,
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("label", {
                              for: "NRIC",
                              class: _normalizeClass(["tw-choice-card", $options.choiceClass('identification_number_type', $data.formData.identification_number_type === 'MyKad')])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "tw-radio",
                                type: "radio",
                                name: "identification_number_type",
                                value: "MyKad",
                                id: "NRIC",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($data.formData.identification_number_type) = $event)),
                                required: "",
                                disabled: $data.isSubmitted,
                                onChange: _cache[11] || (_cache[11] = $event => ($options.clearFieldError('identification_number_type')))
                              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_61), [
                                [_vModelRadio, $data.formData.identification_number_type]
                              ]),
                              _hoisted_62
                            ], 2 /* CLASS */),
                            _createElementVNode("label", {
                              for: "Passport",
                              class: _normalizeClass(["tw-choice-card", $options.choiceClass('identification_number_type', $data.formData.identification_number_type === 'Passport')])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "tw-radio",
                                type: "radio",
                                name: "identification_number_type",
                                id: "Passport",
                                value: "Passport",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($data.formData.identification_number_type) = $event)),
                                required: "",
                                disabled: $data.isSubmitted,
                                onChange: _cache[13] || (_cache[13] = $event => ($options.clearFieldError('identification_number_type')))
                              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_63), [
                                [_vModelRadio, $data.formData.identification_number_type]
                              ]),
                              _hoisted_64
                            ], 2 /* CLASS */),
                            _createElementVNode("label", {
                              for: "Army",
                              class: _normalizeClass(["tw-choice-card", $options.choiceClass('identification_number_type', $data.formData.identification_number_type === 'MyTentera')])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "tw-radio",
                                type: "radio",
                                name: "identification_number_type",
                                id: "Army",
                                value: "MyTentera",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($data.formData.identification_number_type) = $event)),
                                required: "",
                                disabled: $data.isSubmitted,
                                onChange: _cache[15] || (_cache[15] = $event => ($options.clearFieldError('identification_number_type')))
                              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_65), [
                                [_vModelRadio, $data.formData.identification_number_type]
                              ]),
                              _hoisted_66
                            ], 2 /* CLASS */)
                          ]),
                          ($data.form_error_data.identification_number_type)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_67, _toDisplayString($data.form_error_data.identification_number_type), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _hoisted_70,
                            _createVNode(_component_InputText, {
                              type: "text",
                              onInput: _cache[16] || (_cache[16] = $event => ($options.handleDashlessInput($event, 'identification_number'))),
                              modelValue: $data.formData.identification_number,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (($data.formData.identification_number) = $event)),
                              placeholder: $options.getPlaceholder($data.formData.identification_number_type),
                              required: $data.formData.identification_number_type,
                              disabled: $data.isSubmitted || $data.formData.identification_number_type === '',
                              id: "identification_number",
                              class: _normalizeClass(["tw-form-input", $options.inputErrorClass('identification_number')])
                            }, null, 8 /* PROPS */, ["modelValue", "placeholder", "required", "disabled", "class"]),
                            ($data.form_error_data.identification_number)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_71, _toDisplayString($data.form_error_data.identification_number), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            _hoisted_73,
                            _createVNode(_component_InputText, {
                              type: "text",
                              onInput: _cache[18] || (_cache[18] = $event => ($options.handleDashlessInput($event, 'individual_tin'))),
                              modelValue: $data.formData.individual_tin,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($data.formData.individual_tin) = $event)),
                              placeholder: "e.g. C1212341234",
                              disabled: $data.isSubmitted,
                              id: "individual_tin",
                              required: "",
                              class: _normalizeClass(["tw-form-input", $options.inputErrorClass('individual_tin')])
                            }, null, 8 /* PROPS */, ["modelValue", "disabled", "class"]),
                            ($data.form_error_data.individual_tin)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString($data.form_error_data.individual_tin), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ]))
                    : ($data.formData.customer_type === 'Company')
                      ? (_openBlock(), _createElementBlock("section", _hoisted_75, [
                          _hoisted_76,
                          _createElementVNode("div", _hoisted_77, [
                            _hoisted_78,
                            _createVNode(_component_InputText, {
                              id: "company-name",
                              type: "text",
                              modelValue: $data.formData.company_name,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($data.formData.company_name) = $event)),
                              placeholder: "e.g. Coffee Shop Sdn. Bhd.",
                              required: "",
                              disabled: $data.isSubmitted,
                              class: _normalizeClass(["tw-form-input", $options.inputErrorClass('company_name')]),
                              onInput: _cache[21] || (_cache[21] = $event => ($options.clearFieldError('company_name')))
                            }, null, 8 /* PROPS */, ["modelValue", "disabled", "class"]),
                            ($data.form_error_data.company_name)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_79, _toDisplayString($data.form_error_data.company_name), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                              _hoisted_82,
                              _createVNode(_component_InputText, {
                                type: "text",
                                onInput: _cache[22] || (_cache[22] = $event => ($options.handleDashlessInput($event, 'company_id'))),
                                modelValue: $data.formData.company_id,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => (($data.formData.company_id) = $event)),
                                placeholder: "e.g. 201909123456",
                                required: "",
                                disabled: $data.isSubmitted,
                                id: "company_id",
                                class: _normalizeClass(["tw-form-input", $options.inputErrorClass('company_id')])
                              }, null, 8 /* PROPS */, ["modelValue", "disabled", "class"]),
                              ($data.form_error_data.company_id)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_83, _toDisplayString($data.form_error_data.company_id), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", _hoisted_84, [
                              _hoisted_85,
                              _createVNode(_component_InputText, {
                                type: "text",
                                onInput: _cache[24] || (_cache[24] = $event => ($options.handleDashlessInput($event, 'company_tin'))),
                                modelValue: $data.formData.company_tin,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => (($data.formData.company_tin) = $event)),
                                placeholder: "e.g. C1212341234",
                                disabled: $data.isSubmitted,
                                id: "company_tin",
                                required: "",
                                class: _normalizeClass(["tw-form-input", $options.inputErrorClass('company_tin')])
                              }, null, 8 /* PROPS */, ["modelValue", "disabled", "class"]),
                              ($data.form_error_data.company_tin)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString($data.form_error_data.company_tin), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _hoisted_88,
                            _createVNode(_component_InputText, {
                              type: "text",
                              onInput: _cache[26] || (_cache[26] = $event => ($options.handleDashlessInput($event, 'company_sst_number'))),
                              modelValue: $data.formData.sst_number,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => (($data.formData.sst_number) = $event)),
                              placeholder: "e.g. X89-2104-12345678",
                              disabled: $data.isSubmitted,
                              id: "company_sst_number",
                              class: _normalizeClass(["tw-form-input", $options.inputErrorClass('company_sst_number')])
                            }, null, 8 /* PROPS */, ["modelValue", "disabled", "class"]),
                            ($data.form_error_data.company_sst_number)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_89, _toDisplayString($data.form_error_data.company_sst_number), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                  _hoisted_90,
                  _createElementVNode("section", _hoisted_91, [
                    _hoisted_92,
                    _createElementVNode("div", _hoisted_93, [
                      _hoisted_94,
                      _createVNode(_component_InputText, {
                        id: "address_line_1",
                        type: "text",
                        modelValue: $data.formData.address_line_1,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => (($data.formData.address_line_1) = $event)),
                        placeholder: "e.g. Unit No, Street Name",
                        disabled: $data.isSubmitted,
                        required: "",
                        class: _normalizeClass(["tw-form-input", $options.inputErrorClass('address_line_1')]),
                        onInput: _cache[29] || (_cache[29] = $event => ($options.clearFieldError('address_line_1')))
                      }, null, 8 /* PROPS */, ["modelValue", "disabled", "class"]),
                      ($data.form_error_data.address_line_1)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_95, _toDisplayString($data.form_error_data.address_line_1), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _hoisted_97,
                      _createVNode(_component_InputText, {
                        id: "address_line_2",
                        type: "text",
                        modelValue: $data.formData.address_line_2,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => (($data.formData.address_line_2) = $event)),
                        placeholder: "e.g. Unit No, Street Name",
                        disabled: $data.isSubmitted,
                        class: "tw-form-input"
                      }, null, 8 /* PROPS */, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", _hoisted_99, [
                        _hoisted_100,
                        _createVNode(_component_Select, {
                          "pt:root:class": "tw-w-full",
                          disabled: $data.isSubmitted,
                          modelValue: $data.formData.country,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => (($data.formData.country) = $event)),
                          options: $data.countries_list,
                          filter: "",
                          optionLabel: "name",
                          optionValue: "name",
                          placeholder: "Select a Country",
                          class: _normalizeClass(["tw-w-full", $options.inputErrorClass('country')]),
                          onChange: _cache[32] || (_cache[32] = $event => ($options.clearFieldError('country')))
                        }, null, 8 /* PROPS */, ["disabled", "modelValue", "options", "class"]),
                        ($data.form_error_data.country)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_101, _toDisplayString($data.form_error_data.country), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _hoisted_103,
                        _createVNode(_component_Select, {
                          "pt:root:class": "tw-w-full",
                          disabled: $data.isSubmitted || $data.formData.country != 'Malaysia',
                          modelValue: $data.formData.state,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => (($data.formData.state) = $event)),
                          options: $options.filteredStateOptions,
                          filter: "",
                          optionLabel: "state",
                          optionValue: "name",
                          placeholder: "Select a State",
                          class: _normalizeClass(["tw-w-full", $options.inputErrorClass('state')]),
                          onChange: _cache[34] || (_cache[34] = $event => ($options.clearFieldError('state')))
                        }, null, 8 /* PROPS */, ["disabled", "modelValue", "options", "class"]),
                        ($data.form_error_data.state)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_104, _toDisplayString($data.form_error_data.state), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        _hoisted_107,
                        (($data.formData.state === '' || $data.formData.state === '17') && $data.formData.country === 'Malaysia')
                          ? (_openBlock(), _createBlock(_component_InputText, {
                              key: 0,
                              type: "text",
                              placeholder: "Please select a state in Malaysia",
                              disabled: "",
                              class: "tw-form-input"
                            }))
                          : ($data.formData.state === '17' && $data.formData.country !== 'Malaysia')
                            ? (_openBlock(), _createBlock(_component_InputText, {
                                key: 1,
                                type: "text",
                                modelValue: $data.formData.city,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => (($data.formData.city) = $event)),
                                required: "",
                                disabled: $data.isSubmitted,
                                placeholder: "e.g. New York",
                                class: _normalizeClass(["tw-form-input", $options.inputErrorClass('city')]),
                                onInput: _cache[36] || (_cache[36] = $event => ($options.clearFieldError('city')))
                              }, null, 8 /* PROPS */, ["modelValue", "disabled", "class"]))
                            : (_openBlock(), _createBlock(_component_Select, {
                                key: 2,
                                modelValue: $data.formData.city,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => (($data.formData.city) = $event)),
                                required: "",
                                disabled: $data.isSubmitted || !($data.formData.state !== '' && $data.formData.state !== '17' && $data.formData.country === 'Malaysia'),
                                class: _normalizeClass(["tw-form-input", $options.inputErrorClass('city')]),
                                placeholder: $options.cityPlaceholder,
                                options: $options.cities(),
                                onChange: _cache[38] || (_cache[38] = $event => ($options.clearFieldError('city')))
                              }, {
                                default: _withCtx(() => [
                                  _createCommentVNode(" <option v-for=\"city, index in cities()\" :key=\"index\" :value=\"city\">{{ city }}</option> ")
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["modelValue", "disabled", "class", "placeholder", "options"])),
                        ($data.form_error_data.city)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_108, _toDisplayString($data.form_error_data.city), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_109, [
                        _hoisted_110,
                        _createVNode(_component_InputText, {
                          type: "text",
                          id: "postal_code",
                          modelValue: $data.formData.postal_code,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => (($data.formData.postal_code) = $event)),
                          placeholder: "e.g. 43200",
                          required: "",
                          disabled: $data.isSubmitted,
                          class: _normalizeClass(["tw-form-input", $options.inputErrorClass('postal_code')]),
                          onInput: _cache[40] || (_cache[40] = $event => ($options.clearFieldError('postal_code')))
                        }, null, 8 /* PROPS */, ["modelValue", "disabled", "class"]),
                        ($data.form_error_data.postal_code)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_111, _toDisplayString($data.form_error_data.postal_code), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["tw-mt-6 tw-grid tw-grid-cols-[auto_1fr] tw-gap-x-3 tw-gap-y-1 tw-rounded-lg tw-border tw-bg-gray-50 tw-p-4", $data.form_error_data.agreement ? 'tw-border-red-600' : 'tw-border-gray-200'])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "agreement",
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => (($data.formData.accept_privacy_policy_and_tac) = $event)),
                      required: "",
                      disabled: $data.isSubmitted,
                      class: _normalizeClass(["tw-mt-1 tw-h-4 tw-w-4 tw-rounded tw-border-gray-300 tw-text-orange-600 focus:tw-ring-orange-500", $options.inputErrorClass('agreement')]),
                      onChange: _cache[42] || (_cache[42] = $event => ($options.clearFieldError('agreement')))
                    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_112), [
                      [_vModelCheckbox, $data.formData.accept_privacy_policy_and_tac]
                    ]),
                    _hoisted_113,
                    ($data.form_error_data.agreement)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_114, _toDisplayString($data.form_error_data.agreement), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */),
                  _createElementVNode("div", _hoisted_115, [
                    _hoisted_116,
                    _createElementVNode("button", {
                      type: "submit",
                      class: _normalizeClass(["tw-inline-flex tw-min-h-11 tw-w-full tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-orange-500 tw-bg-orange-500 tw-px-5 tw-py-2.5 tw-text-sm tw-font-bold tw-text-white tw-shadow-sm tw-transition hover:tw-border-orange-600 hover:tw-bg-orange-600 disabled:tw-cursor-not-allowed disabled:tw-opacity-70 sm:tw-w-auto", { 'tw-border-green-600 tw-bg-green-600 hover:tw-border-green-600 hover:tw-bg-green-600': $data.isSubmitted }]),
                      disabled: $data.isSubmitting || $data.isSubmitted
                    }, _toDisplayString($data.isSubmitted ? "Submitted" : ($data.isSubmitting ? "Submitting..." : "Submit")), 11 /* TEXT, CLASS, PROPS */, _hoisted_117)
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]))
            : _createCommentVNode("v-if", true)
  ]))
}